import { useTranslation } from "react-i18next";
import clsx from "clsx";

type Props = {
  isSubscribe: boolean;
  isBought?: boolean;
  isActive?: boolean;
};

export default function EstateImprovementStatus({ isSubscribe, isBought, isActive }: Props) {
  const { t } = useTranslation("estate");

  const getStatusKey = () => {
    if (isSubscribe) {
      return isActive ? "active" : "notActive";
    }
    return isBought ? "purchased" : "notPurchased";
  };

  const getLabelKey = () => (isSubscribe ? "improvementStatus" : "purchaseStatus");

  return (
    <div className="flex justify-between items-center py-3.5 px-1 border-b border-b-[#191919]">
      <p className="text-16 font-medium text-white/50">
        {t(`estate.improvements.${getLabelKey()}`)}:
      </p>
      <p className={clsx("text-16 font-medium", isActive ? "text-[#84FF97]" : "text-[#FF4E4E]")}>
        {t(`estate.improvements.statusesList.${getStatusKey()}`)}
      </p>
    </div>
  );
}
